<template>
  <div :class="['micad_message',getType(type)]">{{message}}</div>
</template>

<script>
export default {
  name: 'Messages',
  data() {
    return {
      message: "Quisque tristique quis leo vitae luctus. Etiam eget ullamcorper orci, quis iaculis libero. Morbi varius ante augue, eu luctus neque tristique non.",
    }
  },
  props: {
    type: String,
  },
  methods: {
    getType(type) {
      if (type !== undefined) {
       return ' micad_message_'+type
      }  
    }
  }
};
</script>

